import React from 'react';
import { Link } from 'react-router-dom';

import styles from './GradeHero.scss';
import Button from 'Components/Button';

const GradeHero = ({ title, dek, imageURI, mediaType, link }) => {
  return (
    <div
      className="GradeHero"
      style={{ backgroundImage: 'url("' + imageURI + '")' }}
    >
      <h2 className="GradeHero__headline">{title}</h2>
      <p className="GradeHero__description">{dek}</p>
      <Button
        customClass=" GradeHero__button"
        buttonSize="hero"
        withAction={true}
        mediaType={mediaType}
        to={link}
      />
    </div>
  );
};

export default GradeHero;
